import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Layout from './WebLayout.styled';

const ShareProject = lazy(() =>
  import('modules/Projects/container/ShareProject'),
);

const WebLayout = ({ children }) => {
  const shareProjectModal = useSelector(
    (state) => state.project.shareProjectModal,
  );

  return (
    <>
      <Layout>{children}</Layout>
      <Suspense>
        <ShareProject show={shareProjectModal} />
      </Suspense>
    </>
  );
};

WebLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WebLayout;
